import { render, staticRenderFns } from "./merchantCategory.vue?vue&type=template&id=d923b7c0&scoped=true&"
import script from "./merchantCategory.vue?vue&type=script&lang=ts&"
export * from "./merchantCategory.vue?vue&type=script&lang=ts&"
import style0 from "./merchantCategory.vue?vue&type=style&index=0&id=d923b7c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d923b7c0",
  null
  
)

export default component.exports